export default __webpack_public_path__ + "static/media/open-sans-latin-400italic.bb915319.woff2";